<div class="form-section" [class.form-section-divider]="divider">
  <div
    class="form-section-header"
    [class.form-section-collapsible]="collapsible"
    [attr.role]="collapsible ? 'button' : null"
    [attr.tabindex]="collapsible ? 0 : null"
    [attr.aria-expanded]="collapsible ? expanded : null"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="toggle(); $event.preventDefault()">
    <div class="d-flex align-items-center">
      @if (icon) {
        <lucide-icon [name]="icon" class="form-section-icon me-2"></lucide-icon>
      }
      <h5 class="form-section-title mb-0">{{ title | translate }}</h5>
    </div>
    @if (description) {
      <p class="form-section-description text-muted mb-0 mt-1">
        {{ description | translate }}
      </p>
    }
    @if (collapsible) {
      <lucide-icon
        [name]="expanded ? 'chevron-up' : 'chevron-down'"
        class="form-section-toggle">
      </lucide-icon>
    }
  </div>
  @if (!collapsible || expanded) {
    <div class="form-section-content">
      <ng-content></ng-content>
    </div>
  }
</div>
